import { MdOutlineCopyright } from "react-icons/md";
export default function Footer() {
  return (
    <>
      <div className="footer-container">
        هرگونه کپی برداری از این قالب پیگیری قانونی دارد
        <MdOutlineCopyright></MdOutlineCopyright>
      </div>
    </>
  );
}
